import { render, staticRenderFns } from "./CarouselStartup.vue?vue&type=template&id=36f03150&"
import script from "./CarouselStartup.vue?vue&type=script&lang=js&"
export * from "./CarouselStartup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports